import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const Markets = ({ template }) => {
  const { messages, locale } = useIntl();

  const contentSection = (
    <Contentwrapper>
      <Title locale={locale}>
        <FormattedMessage id={`${template}.markets.title`} />
      </Title>
      <Subtitle>
        <FormattedMessage id={`${template}.markets.paragraph`} />
      </Subtitle>
    </Contentwrapper>
  );

  const imageSection = (
    <ImageWrapper>
      <StyledImage
        src={messages[`${template}.markets.image.src`]}
        alt={messages[`${template}.markets.image.alt`]}
      />
    </ImageWrapper>
  );

  return (
    <StyledSection>
      <StyledContentBlock>
        {template === 'bitcoin' ? (
          <>
            {imageSection}
            {contentSection}
          </>
        ) : (
          <>
            {contentSection}
            {imageSection}
          </>
        )}
      </StyledContentBlock>
    </StyledSection>
  );
};

Markets.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Markets;
